var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83987 9.88623C6.93298 7.60933 10.3375 6.13768 12.0261 5.41574C16.8741 3.36097 17.8818 3 18.5355 3C18.6716 3 18.9985 3.02777 19.2164 3.19437C19.3798 3.33321 19.4342 3.52757 19.4615 3.66641C19.4887 3.80524 19.516 4.11068 19.4887 4.36059C19.2164 7.16506 18.0997 14.0235 17.5005 17.1612C17.2554 18.494 16.7651 18.9383 16.3021 18.9938C15.2944 19.0771 14.5046 18.2997 13.5241 17.661C11.9989 16.6336 11.1273 15.995 9.62933 14.9954C7.91347 13.8292 9.03014 13.1905 10.0106 12.1631C10.2558 11.8855 14.7497 7.74817 14.8314 7.35943C14.8314 7.3039 14.8586 7.13729 14.7497 7.05399C14.6407 6.97069 14.5046 6.99846 14.3956 7.02623C14.2322 7.05399 11.781 8.72002 7.01469 11.9965C6.30655 12.4963 5.68013 12.7185 5.10818 12.7185C4.48175 12.7185 3.28337 12.3575 2.38459 12.0521C1.29515 11.6911 0.423604 11.4967 0.505312 10.8858C0.58702 10.5526 1.02279 10.2194 1.83987 9.88623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b7eb247f836bdca32e07ad7bebc85458.svg";
export { ForwardRef as ReactComponent };